import React from "react";
import { Route, Routes, Outlet, useLocation } from "react-router-dom";
import GetResearchExperience from "../GetResearchExperience/GetResearchExperience";
import ExploreCareers from "../ExploreCareers/ExploreCareers";
import FindGraduateSchools from "../FindGraduateSchools/FindGraduateSchools";
import TalkToAnExpert from "../TalkToAnExpert/TalkToAnExpert";
import FindInternships from "../FindInternships/FindInternships";
import Bookmarks from "../Bookmarks/Bookmarks";
import Set from "../Set/Settings";
import Subhead from "../../components/Subhead/Subhead";
import Footer from "../../components/Footer/Footer";
import { Mentors } from "../Mentors/Mentors";
import Sidebar from "../../components/Sidebar/Sidebar";
import PopupModals from "../../components/PopupModals/PopupModals";
import { useWithRecommendations } from "./use-with-recommendations";


export const PATHS_WITH_SUBHEAD = [
  "",
  "/get-research-experience",
  "/explore-careers",
  "/find-graduate-schools",
  "/talk-to-an-expert",
  "/find-internships",
];

export const TARGET_PAGE_URL_PARAM = "targetPageRoute";

const MainContent = () => {
  const location = useLocation();

  // Check if current path should show Subhead
  const shouldShowSubhead = PATHS_WITH_SUBHEAD.some(path => location.pathname.includes(path));

  return (
    <div
      className={`main-container`}
    >
      {shouldShowSubhead && <Subhead />}
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

const RecommenderPage = () => {
  const { getRecommendations } = useWithRecommendations();
  console.log(getRecommendations());
  return (
    <>
      <PopupModals />
      <Sidebar>
        <Routes>
            <Route
              path="/"
              element={<MainContent />}
            >
            {/* Default route set to Find Graduate Schools */}
            <Route
              index
              element={<FindGraduateSchools />}
            />
            <Route
              path="get-research-experience"
              element={<GetResearchExperience />}
            />
            <Route
              path="explore-careers"
              element={<ExploreCareers />}
            />
            <Route
              path="find-graduate-schools"
              element={<FindGraduateSchools />}
            />
            <Route
              path="talk-to-an-expert"
              element={<TalkToAnExpert />}
            />
            <Route
              path="find-internships"
              element={<FindInternships />}
            />
            <Route
              path="bookmarks"
              element={<Bookmarks />}
            />
            <Route
              path="settings"
              element={<Set />}
            />
            <Route
              path="mentors"
              element={<Mentors />}
            />
          </Route>
        </Routes>
      </Sidebar>
      <Footer />
    </>
  );
};

export default RecommenderPage;
